<template>
  <div v-if="isRender" id="app" style="height: 100%;">
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {
      isRender: false,
      routerParams: {}
    }
  },
  watch: {
    $route (to, from) { // 兼容首次上报
      const params = { to, from }
      if (this.isRender) {
        this.$nextTick(() => { // 等组件渲染完成再派发
          this.$EventBus.$emit('routeChange', params)
        })
      } else {
        this.routerParams = params
      }
    }
  },

  beforeMount () {
    this.preventBodyDrag()
  },

  created () {
    window.addEventListener('message', this.registerMessageListener, false)
  },

  destroyed () {
    window.removeEventListener('message', this.registerMessageListener, false)
  },

  methods: {
    registerMessageListener (e) { // 同步用户权益
      const userInfo = e?.data?.userInfo
      const infoc = e?.data?.infoc || {}

      if (e?.data?.type) { return } // webpack

      this.$store.dispatch('vuexUpdateUserInfo', userInfo) // 内嵌页，不建议存储用户信息，应该由外部传入
      this.$store.commit('vuexUpdateInfoc', infoc)

      this.isRender = true
      this.$nextTick(() => {
        this.$EventBus.$emit('routeChange', this.routerParams)
      })
    },

    preventBodyDrag () {
      const bodyEl = document.getElementsByTagName('body')[0]
      function preventDefault (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      bodyEl.addEventListener('dragleave', preventDefault)
      bodyEl.addEventListener('drop', preventDefault)
      bodyEl.addEventListener('dragenter', preventDefault)
      bodyEl.addEventListener('dragover', preventDefault)
    }
  }
}
</script>
<style lang="scss">
  @import "@/assets/scss/global.scss";
</style>
